// Defaults
Splide.defaults = {
    type: 'slider',
    lazyLoad: 'nearby',
    preloadPages: 1,
    arrows: 'slider',
    pagination: false,
    autoplay: false,
    reducedMotion: true,
    autoHeight: true,
    perPage: 1,
    gap: false
}

// Home
if(typeof(document.querySelector('.slide-home.splide')) != 'undefined' && document.querySelector('.slide-home.splide') != null) {
    const SplideHome = document.querySelectorAll('.slide-home.splide');

    for (var i = 0; i < SplideHome.length; i++) {
        const splide = new Splide(SplideHome[i], {
            type: 'slider',
            arrows: false,
            autoplay: true
        });

        splide.mount();
    }

    const SplideProducts = document.querySelectorAll('.product-slider.splide');

    for (var i = 0; i < SplideProducts.length; i++) {
        const splide = new Splide(SplideProducts[i], {
            type: 'slider',
            arrows: false,
            perPage: 4,
            breakpoints: {
                999: {
                    perPage: 3,
                },
                699: {
                    perPage: 2,
                },
                499: {
                    perPage: 1,
                },
            }
        });

        splide.mount();
    }
}
